import React, { useState, useEffect, useRef } from 'react';
import { Upload, Button, message, Progress, Card, Modal, Breadcrumb } from 'antd';
import { 
  CloudUploadOutlined, 
  VideoCameraOutlined, 
  PictureOutlined, 
  CloseOutlined, 
  PlayCircleOutlined,
  CheckCircleTwoTone 
} from '@ant-design/icons';
import { getOSSToken } from '../../../api/common';
import { getFileExtension, generateRandomString } from '../../../utils';
import { uploadToOSS } from '../../../api/common/upload'
import { useNavigate, Link } from 'react-router-dom';
import styles from './index.module.scss';
import type { UploadFile, UploadProps } from 'antd'
import ImgCrop from 'antd-img-crop';
import { createTemplate, getTwinProcessStatus } from '../../../api/clone';
import { AxiosResponse, AxiosError } from 'axios';
import { RcFile } from 'antd/es/upload/interface';
import type { OSSTokenResponse } from '../../../types/oss';
import VideoPlayer from '../../components/VideoPlayer';
import { clear } from 'console';
import { useTranslation } from 'react-i18next';
import { getUserProfile } from '../../../api/user';
import type { UserInfo } from '../../../types/user' 

const ElegantDigitalHumanCreator = () => {
  const [activeOption, setActiveOption] = useState<string>('video');
  const [sourceFile, setSourceFile] = useState<Blob | null>(null);
  const [fileName, setFileName] = useState<string>('');
  const [uploadProgress, setUploadProgress] = useState<number>(0);
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [videoUrl, setVideoUrl] = useState<string | null>(null);
  const [filePreviewUrl, setFilePreviewUrl] = useState<string | undefined>(undefined);
  const [generateTwinLoading, setGenerateTwinLoading] = useState<boolean>(false)
  const [currentTaskStatus, setCurrentTaskStatus] = useState<string>('正在排队中');
  const [generatingProgress, setGeneratingProgress] = useState<number>(0);
  const timerRef = useRef<number | null>(null)
  const [userInfo, setUserInfo] = useState<UserInfo|null>(null)

  const navigate = useNavigate();
  const { t } = useTranslation();

  const routerItems = [
    {
      title: <Link to="/console/clone">{t('clone.template.video_template')}</Link>
    },
    {
      title: t('clone.template.create_template')
    }
  ]

  useEffect(() => {
    handleFetchUserInfo()
  }, [])

  useEffect(() => {
    if (sourceFile) {
      const url = URL.createObjectURL(sourceFile);
      setFilePreviewUrl(url);

      // 组件卸载时释放 URL
      return () => {
        URL.revokeObjectURL(url);
      };
    }
  }, [sourceFile]);

  useEffect(() => {
    return () => {
      clearTimer();
    };
  }, []);

  const handleFetchUserInfo = async () => {
    getUserProfile().then((res: AxiosResponse) => {
      if (res.data.status === 200) {
        setUserInfo(res.data.data)
        // console.log(res.data)
      }
    })
  }

  const handleOptionClick = (option: string) => {
    setActiveOption(option);
    setSourceFile(null);
    setUploadProgress(0);
    setGeneratingProgress(0);
    setFileList([]);
    // disabled or clearinterval
    clearTimer()
    setGenerateTwinLoading(false)
  };

  const handleUpload: UploadProps['customRequest'] = (options) => {
    const { file } = options

    if (!file) {
      message.error("请选择文件");
      return;
    }

    if ((file as RcFile).name) {
      setFileName((file as RcFile).name)
      setSourceFile((file as RcFile))
    }
  };

  const handleDeleteImage = () => {
    setSourceFile(null);
    setFileList([]);
    setUploadProgress(0);
    
    clearTimer()
    setGenerateTwinLoading(false)
    setGeneratingProgress(0);

  };

  const clearTimer = () => {
    if (timerRef.current) {
      window.clearInterval(timerRef.current);
      timerRef.current = null;
    }
  };

  const handleGenerate = async () => {
    if (!sourceFile) {
      if (activeOption === 'image') {
        message.error('请上传一个图片');
        return
      }
      message.error('请上传一个视频');
      return;
    }
    setVideoUrl(null)
    setGenerateTwinLoading(true)

    const sourceType = activeOption === 'image' ? 0 : 1
    createTemplate({
      sourceFile,
      sourceType
    }).then((res: AxiosResponse) => {
      setGeneratingProgress(1)

      if (res.data.status === 200) {

        if (timerRef.current) window.clearInterval(timerRef.current)

        timerRef.current = window.setInterval(() => {

          setGeneratingProgress((prevProgress) => {
            if (prevProgress < 96) {
              return prevProgress + Math.floor(Math.random() * 3) + 1
            }
            return prevProgress
          })
          getTwinProcessStatus({ id: res.data.data['id'] }).then((_res: AxiosResponse) => {
            if (_res.data.status === 200) {
              var statusId: number = _res.data.data.statusId
              if (statusId === 3) {
                setCurrentTaskStatus('正在排队中')
              } else if (statusId === 4) {
                setCurrentTaskStatus('正在处理中')
              } else if (statusId === 5) {
                clearTimer()
                setVideoUrl(_res.data.data.videoUrl)
                setGeneratingProgress(100)
                setGenerateTwinLoading(false)
                

                Modal.confirm({
                  centered: true,
                  icon: <CheckCircleTwoTone />,
                  title: '任务提示',
                  content: '您的数字分身模板已经完成，现在使用模板去创建视频吧',
                  okText: '好的',
                  cancelText: '取消',
                  onOk() {
                    navigate('/console/clone/videoCreate')
                  },
                  onCancel() {
                    // console.log('Cancel');
                  },
                });
              }
            } else {

            }
          }).catch((err: AxiosError) => {
            clearTimer()
            setGenerateTwinLoading(false)
          })

        }, 4000)

      } else if (res.data.status === 1008) {
        message.error("上传失败，请稍后再试")
        setGeneratingProgress(0)
        setGenerateTwinLoading(false)
      } else if (res.data.status === 1009) {
        setGeneratingProgress(0)
        setGenerateTwinLoading(false)
        Modal.info({
          title: '生成提示',
          content: '超出当前套餐额度，需要释放一个模板',
          centered: true
        })
        // setGenerateTwinLoading(false)
      } else if (res.data.status === 1011) {
        
        message.error(res.data.message)
        setGeneratingProgress(0)
        setGenerateTwinLoading(false)
      }


    }).catch((err: AxiosError) => {
      console.log(err)
      setGenerateTwinLoading(false)
    })


    // message.error('Upload failed. Please try again.');
    //setGenerateTwinLoading(false)
    // setGeneratingProgress(0)



  };

  const handleGenerateCancel = () => {
    clearTimer()
    navigate('/console/clone')
  }

  const handleBeforeVideoUpload: UploadProps['beforeUpload'] = (file: RcFile) => {
    // console.log('beforeUpload executed. File size:', file.size);
    var max_size_mb = 300 
    if (userInfo?.planId) {
      if (userInfo?.planId > 1) max_size_mb = 1024
    }

    var max_size_bytes = max_size_mb * 1000 * 1000
    if (file.size > max_size_bytes) {
        message.error(`文件大小不能超过${max_size_mb}MB!`);
        return false; 
    }
    // 校验通过
    return true; 
  };

  const handleBeforeImageUpload: UploadProps['beforeUpload'] = (file: RcFile) => {
    // console.log('beforeUpload executed. File size:', file.size);
    var max_size_mb = 10
    if (userInfo?.planId) {
      if (userInfo?.planId > 1) max_size_mb = 30
    }

    var max_size_bytes = max_size_mb * 1000 * 1000
    if (file.size > max_size_bytes) {
        message.error(`文件大小不能超过${max_size_mb}MB!`);
        return false; 
    }
    // 校验通过
    return true; 
  };
  


  return (
    <div className={styles.container}>
      <Card className={styles.card}>

        <Breadcrumb items={routerItems} />
        <div className={styles.optionsContainer}>
          <Button
            type={activeOption === 'image' ? 'primary' : 'default'}
            icon={<PictureOutlined />}
            onClick={() => handleOptionClick('image')}
            className={styles.optionButton}
          >
            
            {t('clone.template.image.title')}
          </Button>
          <Button
            type={activeOption === 'video' ? 'primary' : 'default'}
            icon={<VideoCameraOutlined />}
            onClick={() => handleOptionClick('video')}
            className={styles.optionButton}
          >
            {t('clone.template.video.title')}
          </Button>
        </div>

        <div className={styles.promptBar}>
          {activeOption === 'image' ? t('clone.template.image.notice'): t('clone.template.image.notice')}
        </div>

        <div className={styles.contentRow}>
          {activeOption === 'image' ?
            <ImgCrop quality={1}>
              <Upload
                accept={".jpeg, .jpg"}
                customRequest={handleUpload}
                showUploadList={false}
                disabled={generateTwinLoading}
                beforeUpload={handleBeforeImageUpload}
              >
                <div className={styles.uploadArea}>
                  {(sourceFile && filePreviewUrl) ? (
                    <div>
                      <img src={filePreviewUrl} alt="Uploaded" className={styles.previewMedia} />

                      <Button
                        icon={<CloseOutlined />}
                        className={styles.deleteButton}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteImage();
                        }}
                      />
                    </div>
                  ) : (
                    uploadProgress > 0 && uploadProgress < 100 ? (
                      <div className={styles.progressWrapper}>
                        <Progress type="circle" percent={uploadProgress} width={80} />
                      </div>
                    ) : (
                      <div>
                        <CloudUploadOutlined className={styles.uploadIcon} />
                        <div className={styles.uploadText}>
                          {t('clone.template.image.tip')}
                        </div>
                        <div className={styles.tipText}> {t('clone.template.video.tip1')} {userInfo?.planId ===1? '10MB': '30MB'}</div>
                        {userInfo?.planId ===1 && <div className={styles.tipText}>{t('clone.template.video.tip3')}</div>}
                      </div>
                    )
                  )

                  }
                </div>
              </Upload>
            </ImgCrop>
            : (
              <Upload
                accept={".mp4"}
                customRequest={handleUpload}
                showUploadList={false}
                disabled={generateTwinLoading}
                beforeUpload={handleBeforeVideoUpload}
              >
                <div className={styles.uploadArea}>
                  {sourceFile && filePreviewUrl ? (
                    <div className={styles.previewWrapper}>
                      <video src={filePreviewUrl} className={styles.previewMedia} />

                      <Button
                        icon={<CloseOutlined />}
                        className={styles.deleteButton}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteImage();
                        }}
                      />
                    </div>
                  ) : (
                    uploadProgress > 0 && uploadProgress < 100 ? (
                      <div className={styles.progressWrapper}>
                        <Progress type="circle" percent={uploadProgress} width={80} />
                      </div>
                    ) : (
                      <div>
                        <CloudUploadOutlined className={styles.uploadIcon} />
                        <div className={styles.uploadText}>
                          {t('clone.template.image.tip')}

                        </div>
                        <div className={styles.tipText}> {t('clone.template.video.tip1')} {userInfo?.planId ===1? '300MB': '1GB'}</div>
                        {userInfo?.planId ===1 && <div className={styles.tipText}>{t('clone.template.video.tip3')}</div>}
                        <div className={styles.tipText}>{t('clone.template.video.tip2')}</div>
                      </div>
                    )
                  )}
                </div>
              </Upload>
            )
          }



          <div className={styles.previewContainer}>
            {
              videoUrl ? <VideoPlayer src={videoUrl} width={365} maxHeight={365} /> :
                (
                  generatingProgress === 0 ?
                    <div>
                      {t('clone.template.tip')}
                    </div> :
                    generatingProgress > 0 && generatingProgress < 100 &&

                    <div className={styles.progressWrapper}>
                      <Progress type="circle" percent={generatingProgress} width={80} />
                      <div className={styles.tips}>{currentTaskStatus}</div>
                    </div>

                )
            }

          </div>

        </div>


        <div className={styles.actionContainer}>
          <Button onClick={handleGenerateCancel} className={styles.cancelButton}>
            {t('cancel')}
          </Button>
          <Button
            type="primary"
            onClick={handleGenerate}
            disabled={!sourceFile}
            className={styles.generateButton}
            loading={generateTwinLoading}
          >
            {t('clone.template.generate_btn')}
          </Button>
        </div>



      </Card>

      
    </div>
  );
};

export default ElegantDigitalHumanCreator;